"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Provider = exports.PROVIDER_KEY = void 0;
const React = __importStar(require("react"));
const oneaudi_os_utils_1 = require("@oneaudi/oneaudi-os-utils");
const oneaudi_os_store_1 = __importDefault(require("@oneaudi/oneaudi-os-store"));
const Hypervisor_1 = require("./Hypervisor");
const useAppState_1 = require("./useAppState");
const useInternalMetaData_1 = require("./useInternalMetaData");
exports.PROVIDER_KEY = 'FA-ProviderContext';
if (!oneaudi_os_store_1.default.has(exports.PROVIDER_KEY)) {
    oneaudi_os_store_1.default.add(exports.PROVIDER_KEY, React.createContext(undefined));
}
const Context = oneaudi_os_store_1.default.get(exports.PROVIDER_KEY);
Context.displayName = 'FeatureApp';
function Provider({ children, ...rest }) {
    const route = globalThis.document?.location?.pathname || '/';
    const [, , parentApp] = (0, useAppState_1.useAppState)();
    const metaDataContext = (0, useInternalMetaData_1.useInternalMetaData)();
    const currentRoot = (0, Hypervisor_1.root)();
    if (process.env.NODE_ENV !== 'production' && !metaDataContext && parentApp) {
        console.warn(`No MetaData Context was found for FeatureApp '${rest.app?.name}' by its parent app ${parentApp?.name}.
       Using only passed props to Provider.`);
    }
    // We merge props and context together so that FA Devs can add extra configuration.
    // metaDataContext takes precedence when conflicts occur.
    const metaData = {
        ...rest,
        ...rest.app,
        ...metaDataContext,
    };
    const [initialOrHydrated] = React.useState((0, oneaudi_os_utils_1.rehydrateValue)(metaData.id) ||
        figureOutInitialDataWhenDevelopersForgotToPassItToTheAppProvider(metaData.id));
    // Register the app on the first run.
    // Using useState init function is a trick that will help us avoid further re-registrations
    const [registeredApp] = React.useState(() => {
        if (metaData.id === 'root' && !!currentRoot) {
            // Are there two root? :alarm:
            metaData.id = (0, oneaudi_os_utils_1.random)();
            if (process.env.NODE_ENV === 'development') {
                console.error('A root is being nested under an existing tenant. This is dangerous because it can create data corruption.');
            }
        }
        if (!metaData.id) {
            // No ID? oO!
            if (!currentRoot) {
                // Let's see if this is the root (tenant).
                metaData.id = 'root';
            }
            else {
                // No ID passed?
                // That's fine, we can generate a random ID.
                metaData.id = (0, oneaudi_os_utils_1.random)();
                // And now let the developer know that the ID may be missing
                if (process.env.NODE_ENV === 'development') {
                    console.warn('Did you forget to forward properties to App from your FeatureApp component?');
                    console.warn('See how to do that here:', 'https://github.com/oneaudi/create-feature-app/blob/main/src/templates/cfa-template/src/app/template-files/FeatureApp.tsx.mustache#L46');
                    console.warn('We assigned a random ID to this instance', metaData.id);
                }
            }
        }
        // Register the app on first run
        const newAppInstance = (0, Hypervisor_1.register)(metaData.id, {
            route,
            id: metaData.id,
            config: { ...currentRoot?.config, ...metaData?.config },
            data: initialOrHydrated,
            name: metaData?.name,
            meta: {
                name: metaData?.name,
                url: metaData?.url,
                version: metaData?.version,
                sharedModule: metaData?.sharedModule,
            },
            parent: parentApp,
        });
        if (metaData.onRegister) {
            metaData.onRegister(newAppInstance);
        }
        return newAppInstance;
    });
    const [app] = React.useState(registeredApp);
    // If initial data changes via props, then save it to app.data
    React.useEffect(() => {
        if (initialOrHydrated && app) {
            app.data = initialOrHydrated;
        }
    }, [initialOrHydrated]);
    return React.createElement(Context.Provider, { value: app }, children);
}
exports.Provider = Provider;
/**
 * Let's try to find hydrated
 * @param contentId
 * @returns
 */
function figureOutInitialDataWhenDevelopersForgotToPassItToTheAppProvider(contentId) {
    const pathToFeatures = 'fields.content.fields.features';
    // Find features in root's (tenant's) data or in SSR initial data as fallback
    const features = (0, oneaudi_os_utils_1.get)((0, Hypervisor_1.rootData)(), pathToFeatures, (0, oneaudi_os_utils_1.get)((0, oneaudi_os_utils_1.rehydrateValue)('root'), pathToFeatures, []));
    return features.find((item) => item?.sys?.id === contentId);
}
